module.exports = __webpack_public_path__ + "static/media/Chuka.27ffe3d4.jpg";